// extracted by mini-css-extract-plugin
module.exports = {"recentlyUpdated":"style_recentlyUpdated__Y1c8Z","clockIcon":"style_clockIcon__UGdPc"};